import { render, staticRenderFns } from "./TemplateConfiguration.vue?vue&type=template&id=41f72c11&scoped=true"
import script from "./TemplateConfiguration.vue?vue&type=script&lang=js"
export * from "./TemplateConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f72c11",
  null
  
)

export default component.exports